<div class="lender-notification-wrapper">
    <div [class]="unread ? 'bg-lendio-red-400' : ''" class="unread-badge"><div>
</div> 